import { render } from "./homePrivate.vue?vue&type=template&id=b067de94&scoped=true"
import script from "./homePrivate.vue?vue&type=script&lang=js"
export * from "./homePrivate.vue?vue&type=script&lang=js"

import "./homePrivate.vue?vue&type=style&index=0&id=b067de94&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b067de94"]])

export default __exports__